import { useQuery } from '@tanstack/react-query';
import { supabase } from '../supabase';
import type { ProgramLocation } from '../../types/location';

export const LOCATIONS_QUERY_KEY = ['admin', 'locations'] as const;

/** The shared `locations` catalog, sorted by name, for admin pickers. */
export function useAdminLocations() {
  return useQuery({
    queryKey: LOCATIONS_QUERY_KEY,
    queryFn: async (): Promise<ProgramLocation[]> => {
      const { data, error } = await supabase.from('locations').select('id, name').order('name');
      if (error) throw error;
      return (data ?? []) as ProgramLocation[];
    },
  });
}
